(() => {
    const wishlistKey = 'hd:wishlist:v1';
    const recentlyViewedKey = 'hd:recently-viewed:v1';
    const maxRecentlyViewed = 8;

    const readStorage = (key) => {
        try {
            const value = JSON.parse(localStorage.getItem(key) || '[]');
            return Array.isArray(value) ? value : [];
        } catch (error) {
            return [];
        }
    };

    const writeStorage = (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            // Private browsing or storage policies may disable localStorage.
        }
    };

    const updateWishlistButtons = (root = document) => {
        const wishlist = new Set(readStorage(wishlistKey));
        root.querySelectorAll('[data-hd-wishlist-button]').forEach((button) => {
            const active = wishlist.has(button.dataset.productId);
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
            button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
            button.setAttribute('title', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
        });
    };

    const toggleWishlist = (button) => {
        const wishlist = new Set(readStorage(wishlistKey));
        const productId = button.dataset.productId;

        if (wishlist.has(productId)) {
            wishlist.delete(productId);
        } else {
            wishlist.add(productId);
        }

        writeStorage(wishlistKey, Array.from(wishlist));
        updateWishlistButtons();
    };

    const createRecentlyViewedCard = (item) => {
        const article = document.createElement('article');
        article.className = 'hd-recently-viewed__card';
        article.setAttribute('role', 'listitem');

        const link = document.createElement('a');
        link.href = item.url;
        link.className = 'hd-recently-viewed__link';

        const media = document.createElement('span');
        media.className = 'hd-recently-viewed__media';

        if (item.image) {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = item.title;
            image.loading = 'lazy';
            image.width = 280;
            image.height = 420;
            media.appendChild(image);
        } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'hd-recently-viewed__placeholder';
            placeholder.textContent = 'Hobidabi';
            media.appendChild(placeholder);
        }

        const content = document.createElement('span');
        content.className = 'hd-recently-viewed__content';
        const title = document.createElement('span');
        title.className = 'hd-recently-viewed__title';
        title.textContent = item.title;
        const price = document.createElement('span');
        price.className = 'hd-recently-viewed__price';
        price.textContent = item.price;

        content.append(title, price);
        link.append(media, content);
        article.appendChild(link);
        return article;
    };

    const renderRecentlyViewed = () => {
        document.querySelectorAll('[data-hd-recently-viewed]').forEach((section) => {
            const currentScript = section.querySelector('[data-hd-current-product]');
            let currentProduct = null;

            if (currentScript) {
                try {
                    currentProduct = JSON.parse(currentScript.textContent);
                } catch (error) {
                    currentProduct = null;
                }
            }

            let history = readStorage(recentlyViewedKey);
            const visibleHistory = history.filter((item) => String(item.id) !== String(currentProduct?.id));
            const limit = Math.min(Number(section.dataset.limit) || maxRecentlyViewed, maxRecentlyViewed);
            const list = section.querySelector('[data-hd-recently-viewed-list]');

            list.replaceChildren(...visibleHistory.slice(0, limit).map(createRecentlyViewedCard));
            section.hidden = list.children.length === 0;

            if (currentProduct?.id) {
                history = history.filter((item) => String(item.id) !== String(currentProduct.id));
                history.unshift(currentProduct);
                writeStorage(recentlyViewedKey, history.slice(0, maxRecentlyViewed));
            }
        });
    };

    const initialize = () => {
        updateWishlistButtons();
        renderRecentlyViewed();

        document.addEventListener('click', (event) => {
            const button = event.target.closest('[data-hd-wishlist-button]');
            if (!button) return;
            event.preventDefault();
            event.stopPropagation();
            toggleWishlist(button);
        });

        const observer = new MutationObserver((mutations) => {
            const addedWishlistButtons = mutations.some((mutation) =>
                Array.from(mutation.addedNodes).some((node) =>
                    node.nodeType === 1 && (node.matches?.('[data-hd-wishlist-button]') || node.querySelector?.('[data-hd-wishlist-button]'))
                )
            );

            if (addedWishlistButtons) {
                updateWishlistButtons();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
        initialize();
    }
})();
